import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import * as Util from '../../../common/utilities';
import { Card, Tabs, TabsPanel } from '@salesforce/design-system-react';

import {
  ExperimentAnalyticsFilter,
  ExperimentDetails,
  ExperimentPerformanceChartDetails,
  ExperimentPerformanceDetails
} from '../';

import './ExperimentPerformance.scss';

export class ExperimentPerformance extends Component {
  componentDidMount() {
    if (this.props.experiment?.status !== 'DRAFT') {
      this.props.actions.getExperimentJobs(this.props.experiment.uuid);
    }
  }
  componentDidUpdate(prevProps) {
    if (Util.propChanged(prevProps, this.props, 'analytics.filter')) {
      if (this.props.experiment?.status !== 'DRAFT') {
        this.props.actions.getExperimentPerformance(
          this.props.experiment,
          this.props.analytics?.filter,
          {
            demo: this.props.flags?.demo,
            demoPerformers: this.props.experiment?.content_test_assets.slice(
              0,
              3
            )
          }
        );
      }
    }
  }

  getI18nID(suffix) {
    return `components.experiment.performance.tab.${suffix}`;
  }

  renderPerformance() {
    const { filter, performance, jobs } = this.props.analytics;

    return (
      <div className="analytics-row-container">
        <div className="analytics-row">
          <ExperimentDetails
            experiment={this.props.experiment}
            filter={filter}
            jobs={jobs}
            details={performance.details}
            performers={performance.performers}
            summary={performance.summary}
          />
        </div>
        <ExperimentPerformanceChartDetails
          actions={this.props.actions}
          experiment={this.props.experiment}
          flags={this.props.flags}
          performance={performance}
          filter={filter}
          session={this.props.session}
        />
      </div>
    );
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { actions, experiment } = this.props;
    const filter = this.props.analytics.filter;

    const jobs = this.props.analytics.jobs || [];
    return (
      <React.Fragment>
        <div className="experiment-performance-analytics">
          <Card hasNoHeader>
            <Tabs id="tabs-performance">
              <TabsPanel
                label={formatMessage({
                  id: this.getI18nID('results')
                })}
              >
                <ExperimentAnalyticsFilter
                  actions={actions}
                  experiment={experiment}
                  filter={filter}
                  jobs={jobs}
                  jobsLoading={this.props.jobsLoading}
                />
                {this.renderPerformance()}
              </TabsPanel>
              <TabsPanel
                label={formatMessage({
                  id: this.getI18nID('details')
                })}
              >
                <ExperimentPerformanceDetails
                  actions={this.props.actions}
                  experiment={experiment}
                  modals={this.props.modals}
                  flags={this.props.flags}
                  location={this.props.location}
                  intl={this.props.intl}
                />
              </TabsPanel>
            </Tabs>
          </Card>
        </div>
      </React.Fragment>
    );
  }
}

ExperimentPerformance.propTypes = {
  actions: PropTypes.shape({
    openModal: PropTypes.func
  }),
  analytics: PropTypes.object.isRequired,
  experiment: PropTypes.object.isRequired,
  flags: PropTypes.object,
  jobsLoading: PropTypes.bool,
  modals: PropTypes.object,
  location: PropTypes.object,
  session: PropTypes.object
};

export default injectIntl(ExperimentPerformance);
